import PropTypes from 'prop-types';
import UIButton from 'UIComponents/button/UIButton';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIForm from 'UIComponents/form/UIForm';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import H2 from 'UIComponents/elements/headings/H2';
import styled from 'styled-components';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function preventDefault(evt) {
  evt.preventDefault();
}
const StyledDiv = styled.div.withConfig({
  displayName: "EditEmailAddressModal__StyledDiv",
  componentId: "sc-1qa9i7c-0"
})(["min-height:400px;"]);
const EditEmailAddressModalBody = ({
  stagedNewEmailAddress,
  onStagedNewEmailAddressChanged,
  stagedPassword,
  onStagePasswordChange,
  hasConflict,
  onKeyUp,
  onFocus,
  onBlur,
  validEmail,
  emailInputFocused
}) => {
  return /*#__PURE__*/_jsxs(StyledDiv, {
    children: [hasConflict ? /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsxs(UIAlert, {
        type: "warning",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.alerts.addEmailAddressConflict_FAILURE",
          options: {
            data: stagedNewEmailAddress
          }
        }), ' ', /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: "https://knowledge.hubspot.com/account/delete-your-hubspot-user"
        })]
      })
    }) : null, /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "userPreferences.descriptions.editEmailAddress"
      })
    }), /*#__PURE__*/_jsxs(UIForm, {
      onSubmit: evt => preventDefault(evt),
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        error: !emailInputFocused && !validEmail,
        validationMessage: !validEmail && !emailInputFocused && /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.labels.invalidEmail"
          })
        }),
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.emailAddress"
        }),
        children: /*#__PURE__*/_jsx(UITextInput, {
          value: stagedNewEmailAddress,
          onKeyUp: onKeyUp,
          onFocus: onFocus,
          onBlur: onBlur,
          "data-test-id": "email-address-input",
          onChange: evt => onStagedNewEmailAddressChanged(evt.target.value)
        })
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.password"
        }),
        children: /*#__PURE__*/_jsx(UITextInput, {
          type: "password",
          "data-test-id": "current-user-password",
          value: stagedPassword,
          onChange: evt => {
            onStagePasswordChange(evt.target.value);
          }
        })
      })]
    })]
  });
};
const EditEmailAddressModal = ({
  stagedNewEmailAddress,
  onStagedNewEmailAddressChanged,
  stagedPassword,
  onStagePasswordChange,
  onSaveNewEmailAddress,
  onCloseModal,
  hasConflict,
  onKeyUp,
  onFocus,
  onBlur,
  validEmail,
  emailInputFocused
}) => {
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCloseModal
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.editEmailAddress"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(EditEmailAddressModalBody, {
        stagedNewEmailAddress: stagedNewEmailAddress,
        onStagedNewEmailAddressChanged: onStagedNewEmailAddressChanged,
        stagedPassword: stagedPassword,
        onStagePasswordChange: onStagePasswordChange,
        hasConflict: hasConflict,
        onKeyUp: onKeyUp,
        onFocus: onFocus,
        onBlur: onBlur,
        validEmail: validEmail,
        emailInputFocused: emailInputFocused
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: onSaveNewEmailAddress,
        disabled: hasConflict || stagedNewEmailAddress.length === 0 || !validEmail,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.save"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: onCloseModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.labels.cancel"
        })
      })]
    })]
  });
};
EditEmailAddressModal.propTypes = {
  onSaveNewEmailAddress: PropTypes.func.isRequired,
  onStagedNewEmailAddressChanged: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  stagedPassword: PropTypes.string.isRequired,
  stagedNewEmailAddress: PropTypes.string.isRequired,
  hasConflict: PropTypes.bool.isRequired,
  onKeyUp: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  validEmail: PropTypes.bool.isRequired,
  emailInputFocused: PropTypes.bool.isRequired
};
export default EditEmailAddressModal;